import { AutoExposureBiProvider } from '@/__generated__/graphql';
import { DbtCloudProvider } from '@/context/DbtCloudProvider';
import DiscoveryUrqlProvider from '@/context/EmbedUrqlProvider';
import { useExposureParams } from '@/hooks/useExposureParams';
import { JobBasedExposureTile } from '../JobBased/JobBasedExposureTile';
import { DataMonitor } from './DataMonitor';

type TileParams = {
  uriOverride?: string;
  dbtInstance?: string;
};

export function ExposureTile({ uriOverride, dbtInstance }: TileParams) {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token') ?? undefined;
  return (
    <DbtCloudProvider dbtInstance={dbtInstance}>
      <DiscoveryUrqlProvider
        source="ExposureTile"
        token={token}
        uri={uriOverride ?? window.location.origin}
      >
        <ExposureTileImpl />
      </DiscoveryUrqlProvider>
    </DbtCloudProvider>
  );
}

function ExposureTileImpl() {
  const {
    environmentId,
    uniqueId,
    environmentType,
    exposureName,
    jobId,
    autoBiProvider,
    biResourceId,
  } = useExposureParams();
  if (jobId && exposureName) {
    return <JobBasedExposureTile exposureName={exposureName} jobId={jobId} />;
  }
  return (
    <>
      <div className="absolute inset-0 top-[50%] bg-bgBackground" />
      <div className="absolute inset-0 flex flex-col justify-center">
        <div className="flex-0 min-h-[352px] bg-bgMain">
          <DataMonitor
            environmentId={environmentId}
            uniqueId={uniqueId}
            environmentType={environmentType}
            autoBiProvider={autoBiProvider as AutoExposureBiProvider}
            biResourceId={biResourceId}
          />
        </div>
      </div>
    </>
  );
}
